import React, { useState } from "react";
import ThreeDotsToolTipUi from "../../../Ui/AllCollections/ToolTip/ThreeDotsToolTipUi";

const ThreeDotsToolTip = (props) => {
  const [UpdatedData, setUpdatedData] = useState([]);

  const OpenEdit = (data) => {
    setUpdatedData(data)
    props.setIsAddNewCollectionModalOpen(true)
  }

  const DeleteCollection = () => {
    props.setIsDeleteCollectionModalOpen(true)
  }

  return (
    <ThreeDotsToolTipUi
      loading={props.loading}
      setLoading={props.setLoading}
      t={props.t}
      isThreeDotOpen={props.isThreeDotOpen}
      index={props.index}
      activeImageIndex={props.activeImageIndex}
      clickedCollection={props.clickedCollection}
      OpenEdit={OpenEdit}
      setIsAddNewCollectionModalOpen={props.setIsAddNewCollectionModalOpen}
      isAddNewCollectionModalOpen={props.isAddNewCollectionModalOpen} onClose={props.onClose} 
      UpdatedData={UpdatedData} 
      DeleteCollection={DeleteCollection}
    />
  );
};

export default ThreeDotsToolTip;
